import dayjs from "dayjs"
import { useEffect } from "react"

import { useSubscriberInfo, useUserQuery } from "../../networking/queries"
import { SubscriptionCampaign } from "../../types"
import { useRouter } from "../../util/router"
import { localStorageItems } from "../../util/storage"

const useDailyPaywallRedirect = () => {
  const { user } = useUserQuery()
  const router = useRouter()
  const { data: subscriber } = useSubscriberInfo()

  const lastSeenPaywall = localStorage.getItem(
    localStorageItems.lastSeenPaywall
  )

  useEffect(() => {
    const needsToSeePaywall = localStorage.getItem(
      localStorageItems.needsToSeePaywall
    )
    if (!user || !subscriber || needsToSeePaywall) return
    if (subscriber?.active_plan?.is_active) return

    const lastSeenPaywallDate = dayjs(lastSeenPaywall)
    const isDifferentDate =
      !lastSeenPaywallDate.isSame(dayjs(), "day") || !lastSeenPaywall

    const isOnCheckoutPage = router.pathname.includes("/checkout")
    const isOnOnboardingPage = router.pathname.includes("/onboard")
    if (isOnCheckoutPage || isOnOnboardingPage) return

    if (isDifferentDate) {
      switch (user.sub_offering) {
        case "referral":
          router.push(
            `/paywall?campaign=${SubscriptionCampaign.DISCOUNT_ANNUAL}`
          )
          break
        case "discounted":
          router.push(
            `/paywall?campaign=${SubscriptionCampaign.SPECIAL_DISCOUNT_ANNUAL}`
          )
          break
        default:
          router.push(`/paywall`)
          break
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, subscriber])
}

export default useDailyPaywallRedirect
